import { render, staticRenderFns } from "./CaseResult.vue?vue&type=template&id=31369c1d"
import script from "./CaseResult.vue?vue&type=script&lang=js"
export * from "./CaseResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports